module.exports = __webpack_public_path__ + "img/ContactUs_Desktop_03.8eaefcdc.jpg";